<template>
	<div class="container print-page" id="print-page-2">
		<heading/>
		<hr />
		<div class="row">
			<div class="col-8">
				<!--left column-->
				<div class="row">
					<div class="col">
						<div class="row">
							<block-wealth/>
							<block-carrying-capacity/>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<h4 class="mt-3">Equipment</h4>

						<block-equipment-equipped/>
						<block-equipment-augments/>
						<block-equipment-magic/>
						<block-equipment-stored/>

					</div>
				</div>
			</div>
			<div class="col-4">
				<!--right column-->

				<block-pools/>
				<block-drone/>
				<block-companion/>
				<block-spells/>
				<block-biography/>
			</div>
		</div>
	</div>
</template>

<script>
let components = {}

components.Heading = () => import('@/components/print/Heading.vue')
components.BlockWealth = () => import('@/components/print/block/Wealth.vue')
components.BlockCarryingCapacity = () => import('@/components/print/block/CarryingCapacity.vue')
components.BlockEquipmentEquipped = () => import('@/components/print/block/EquipmentEquipped.vue')
components.BlockEquipmentAugments = () => import('@/components/print/block/EquipmentAugments.vue')
components.BlockEquipmentMagic = () => import('@/components/print/block/EquipmentMagic.vue')
components.BlockEquipmentStored = () => import('@/components/print/block/EquipmentStored.vue')
components.BlockPools = () => import('@/components/print/block/Pools.vue')
components.BlockDrone = () => import('@/components/print/block/Drone.vue')
components.BlockCompanion = () => import('@/components/print/block/Companion.vue')
components.BlockSpells = () => import('@/components/print/block/Spells.vue')
components.BlockBiography = () => import('@/components/print/block/Biography.vue')

export default {
	components,
}
</script>

<style scoped>

</style>